/*
 * Pufien premium PDP — küçük yardımcı (P04, 8 Ekim 2026). Yalnız ürün sayfasında yüklenir.
 *
 * 1) Varyant değişince ("variant:update", Horizon) sunucunun yeni HTML'inden [data-pf-sync="…"]
 *    parçalarını eşitler: teslimat kutusu (tükenmiş varyantta görünmez), fiyat/eşik satırı, güven satırı.
 *    Teslimat kutusunun tarihini pf-shipping-eta.js kendi MutationObserver'ı ile doldurur.
 * 2) Sepet değişince ("cart:update") fiyat/eşik satırını /cart.js toplamıyla yeniden hesaplar.
 *    Kurallar snippets/pf-price-line.liquid ile birebir aynı; biçim D16 ("401 TL", "1.299 TL").
 *    Seçili varyant zaten sepetteyse ürün fiyatı ikinci kez eklenmez, "Bu ürünle" öneki düşer (P05 düzeltmesi).
 *    Ürün sepette değilse ve eşik altındaysa "· 2 çiftle X TL" ipucu eklenir (P09).
 * 3) "Aynı bedende ikinci renk" modülü (P09): toplam + iki satırlık sepete ekleme; yalnız modül açıkken sayfada var.
 * 4) "Kışlık takımı tamamla" takım satırı (P10, snippets/pf-complete-set.liquid): sepet değişince yeniden hesaplanır.
 *    Hızlı ekleme penceresindeki (başka ürünün) varyant değişimi ana ürünün satırlarına dokunmaz (P10).
 *    Kuruşlu tutar kuruşuyla yazılır ("149,50 TL"); "kalan" tutarlar yukarı yuvarlanır (snippets/pf-money ile aynı).
 */
(function () {
  if (window.__pfPremium) return;
  window.__pfPremium = true;

  function tl(cents, ceil) {
    var t = ceil ? Math.ceil(cents / 100) : Math.floor(cents / 100);
    var k = ceil ? 0 : Math.round(cents) % 100;
    return String(t).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (k ? ',' + (k < 10 ? '0' : '') + k : '') + ' TL';
  }

  function takimMetni(el, sepet, kalemler) {
    var ana = +el.dataset.ana || 0;
    var ship = +el.dataset.ship || 75000;
    var disc = +el.dataset.disc || 100000;
    var discp = el.dataset.discp || '10';
    var urunler = kalemler.map(function (k) { return String(k.product_id); });
    var anaSepette = kalemler.some(function (k) { return String(k.variant_id) === el.dataset.anaVariant; });
    var toplam = ana;
    var etki = sepet + (anaSepette ? 0 : ana);
    (el.dataset.ekler || '').split(',').forEach(function (s) {
      if (!s) return;
      var p = s.split(':');
      var f = +p[1] || 0;
      toplam += f;
      if (urunler.indexOf(p[0]) < 0) etki += f;
    });
    var m = 'Takım: <strong>' + tl(toplam) + (el.dataset.baslayan === '1' ? "'den başlayan" : '') + '</strong>';
    if (etki >= disc) return m + ' · kargo bedava ve sepette %' + discp + ' indirim';
    if (etki >= ship) return m + ' · kargo bedava';
    return m + ' · kargo bedavaya ' + tl(ship - etki, true) + ' kaldı';
  }

  function satirMetni(el, sepet) {
    var fiyat = +el.dataset.fiyat || 0;
    var ship = +el.dataset.ship || 75000;
    var disc = +el.dataset.disc || 100000;
    var discp = el.dataset.discp || '10';
    var sepette = el.dataset.sepette === '1';
    var toplam = sepette ? sepet : sepet + fiyat;
    if (toplam >= disc) {
      return sepette
        ? 'Sepetinizde <strong>kargo bedava</strong> ve <strong>%' + discp + ' indirim</strong>'
        : 'Bu ürünle <strong>kargo bedava</strong> ve sepette <strong>%' + discp + ' indirim</strong>';
    }
    if (toplam >= ship) {
      return (sepette ? 'Sepetinizde <strong>kargo bedava</strong>. %' : 'Bu ürünle <strong>kargo bedava</strong>. Sepette %') +
        discp + ' indirime <strong>' + tl(disc - toplam, true) + '</strong> kaldı';
    }
    var metin = (sepette ? 'Kargo bedavaya' : 'Bu ürünle kargo bedavaya') + ' <strong>' + tl(ship - toplam, true) + '</strong> kaldı';
    if (!sepette) {
      var kalan2 = ship - toplam - fiyat;
      metin += kalan2 > 0 ? ' · 2 çiftle ' + tl(kalan2, true) : ' · 2 çiftle kargo bedava';
    }
    return metin;
  }

  function satirlariGuncelle(sepet, kalemler) {
    document.querySelectorAll('[data-pf-price-line]').forEach(function (el) {
      if (typeof sepet === 'number') el.dataset.sepet = String(sepet);
      if (kalemler) {
        el.dataset.sepette = kalemler.some(function (k) { return String(k.variant_id) === el.dataset.variant; }) ? '1' : '0';
      }
      var m = el.querySelector('[data-pf-price-line-metin]');
      if (m) m.innerHTML = satirMetni(el, +el.dataset.sepet || 0);
    });
    if (kalemler && typeof sepet === 'number') {
      document.querySelectorAll('[data-pf-set-toplam]').forEach(function (el) { el.innerHTML = takimMetni(el, sepet, kalemler); });
    }
  }

  function sepettenGuncelle() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { satirlariGuncelle(c.items_subtotal_price != null ? c.items_subtotal_price : c.total_price, c.items || []); })
      .catch(function () {});
  }

  document.addEventListener('variant:update', function (e) {
    if (e.target && e.target.closest && e.target.closest('quick-add-dialog')) return;
    var d = e.detail && e.detail.data;
    if (!d || !d.html) return;
    document.querySelectorAll('[data-pf-sync]').forEach(function (el) {
      var anahtar = el.getAttribute('data-pf-sync');
      var yeni = d.html.querySelector('[data-pf-sync="' + anahtar + '"]');
      if (yeni && yeni.innerHTML !== el.innerHTML) el.innerHTML = yeni.innerHTML;
    });
    satirlariGuncelle();
  });

  document.addEventListener('cart:update', sepettenGuncelle);

  /* 3) "Aynı bedende ikinci renk" (P09, snippets/pf-pair-offer.liquid): renk seçilince toplam, düğmeyle iki satır sepete. */
  document.addEventListener('change', function (e) {
    var r = e.target && e.target.closest ? e.target.closest('[data-pf-pair] input[type="radio"]') : null;
    if (!r) return;
    var kutu = r.closest('[data-pf-pair]');
    var toplam = (+kutu.dataset.anaFiyat || 0) + (+r.dataset.fiyat || 0);
    var kalan = (+kutu.dataset.ship || 75000) - (+kutu.dataset.sepet || 0) - toplam;
    kutu.querySelector('[data-pf-pair-toplam]').innerHTML = 'İki çift: <strong>' + tl(toplam) + '</strong>' +
      (kalan > 0 ? ' · Kargo bedavaya ' + tl(kalan, true) + ' kaldı' : ' · Kargo bedava');
    kutu.querySelector('[data-pf-pair-ekle]').disabled = false;
  });
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-pf-pair-ekle]') : null;
    if (!btn) return;
    var kutu = btn.closest('[data-pf-pair]');
    var sec = kutu.querySelector('input[type="radio"]:checked');
    var durum = kutu.querySelector('.pf-pair__durum');
    if (!sec) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +kutu.dataset.ana, quantity: 1 }, { id: +sec.value, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('ekleme'); return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        durum.textContent = 'İki çift sepete eklendi.';
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: c, sourceId: 'pf-pair-offer', data: { source: 'pf-pair-offer', itemCount: c.item_count } }
        }));
        btn.disabled = false;
      })
      .catch(function () { durum.textContent = 'Sepete eklenemedi, lütfen tekrar deneyin.'; btn.disabled = false; });
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) sepettenGuncelle(); });
})();
